// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import { getCompanyProfile } from "../../../Services/Services";

// pdfMake.vfs = pdfFonts.vfs;

// const imageUrlToBase64 = async (url) => {
//   const response = await fetch(url);

//   if (!response.ok) {
//     throw new Error("Failed to load company logo");
//   }

//   const blob = await response.blob();

//   return await new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onloadend = () => resolve(reader.result);
//     reader.onerror = reject;

//     reader.readAsDataURL(blob);
//   });
// };

// export const generatePurchasePdf = async (indent) => {
//   const company = await getCompanyProfile();
//   const logoImg = company.logo_url
//     ? await imageUrlToBase64(company.logo_url)
//     : null;
//   const tableBody = [
//     [
//       { text: "Sl. No.", style: "tableHeader" },
//       { text: "Category", style: "tableHeader" },
//       // { text: "Sub Category", style: "tableHeader" },
//       { text: "Item", style: "tableHeader" },
//       { text: "Product Type", style: "tableHeader" }, // ✅ Added
//       { text: "UOM", style: "tableHeader" },
//       { text: "PO Qty.", style: "tableHeader" },
//       { text: "Received Qty.", style: "tableHeader" },
//       { text: "Rate", style: "tableHeader" },
//       { text: "Amount", style: "tableHeader" },
//       { text: "Gst Per", style: "tableHeader" },
//       { text: "GST Amt", style: "tableHeader" },
//       { text: "Total Amt", style: "tableHeader" },
//     ],
//     ...indent.items.map((item, i) => [
//       { text: i + 1, alignment: "center" },
//       { text: item.category_name || "-", alignment: "center" },
//       // { text: item.sub_category_name || "-", alignment: "center" },
//       { text: item.item_name || "-", alignment: "center" },
//       { text: item.size_name || "-", alignment: "center", fontSize: 8 }, // ✅ Added
//       { text: item.unit_name || "-", alignment: "center" },
//       { text: item.quantity ?? "-", alignment: "center" },
//       { text: item.received_qty ?? "-", alignment: "center" },
//       {
//         text: item.rate ? `Rs. ${item.rate}` : "-",
//         alignment: "center",
//       },
//       {
//         text: item.amount
//           ? `₹${Number(item.amount).toLocaleString("en-IN")}`
//           : "-",
//         alignment: "center",
//       },
//       {
//         text: item.gst_percentage
//           ? `${Number(item.gst_percentage).toLocaleString("en-IN")}`
//           : "-",
//         alignment: "center",
//       },
//       {
//         text: item.gst_amount
//           ? `₹${Number(item.gst_amount).toLocaleString("en-IN")}`
//           : "-",
//         alignment: "center",
//       },
//       {
//         text: item.item_total
//           ? `₹${Number(item.item_total).toLocaleString("en-IN")}`
//           : "-",
//         alignment: "center",
//       },
//     ]),
//   ];

//   const total = `₹${indent.items
//     .reduce((sum, i) => sum + (parseFloat(i.amount) || 0), 0)
//     .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   const gst_amount = indent.gst_amount ? `₹${Number(indent.gst_amount).toLocaleString("en-IN")}` : "-";
//   const final_amount = `₹${(parseFloat(indent.final_amount) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   const other_expense = indent.other_expense ? `₹${Number(indent.other_expense).toLocaleString("en-IN")}` : "-";
//   const docDefinition = {
//     pageOrientation: "landscape",
//     pageSize: "A4",
//     pageMargins: [10, 10, 10, 10],
//     defaultStyle: { fontSize: 9 },

//     footer: function (currentPage, pageCount) {
//       return {
//         text: "Page " + currentPage + " of " + pageCount,
//         alignment: "right",
//         fontSize: 8,
//         italics: true,
//         margin: [0, 5, 20, 0],
//       };
//     },
//     content: [
//       {
//         table: {
//           widths: ["100%"],
//           body: [
//             // Row 1 - Header with logo and company details
//             [
//               {
//                 table: {
//                   widths: [80, "*"],
//                   body: [
//                     [
//                       {
//                         image: "logoImg",
//                         width: 80,
//                         rowSpan: 2,
//                         margin: [0, 0, 5, 0],
//                       },
//                       {
//                         text: `${company.company_name || ""}\n${company.tagline || ""}\n${company.address || ""
//                           }\nPhone: ${company.phone || ""} | Email: ${company.email || ""}`,
//                         alignment: "center",
//                         bold: true,
//                         margin: [0, 0, 0, 0],
//                       },
//                     ],
//                     [
//                       {}, // ✅ Empty cell because logo uses rowSpan: 2
//                       {
//                         columns: [
//                           { width: "*", text: "" },
//                           {
//                             table: {
//                               widths: ["auto"],
//                               body: [
//                                 [
//                                   {
//                                     text: "Purchase List",
//                                     alignment: "center",
//                                     fontSize: 10,
//                                     bold: true,
//                                     margin: [30, 0, 30, 0],
//                                     border: [true, true, true, true],
//                                   },
//                                 ],
//                               ],
//                             },
//                             layout: {
//                               hLineWidth: () => 0.3,
//                               vLineWidth: () => 0.3,
//                               hLineColor: () => "#000",
//                               vLineColor: () => "#000",
//                             },
//                             margin: [50, 0, 0, 0],
//                           },
//                           { width: "*", text: "" },
//                         ],
//                       },
//                     ],
//                   ],
//                 },
//                 layout: "noBorders",
//               },
//             ],

//             // Row 2 - Purchase Details Info
//             [
//               {
//                 columns: [
//                   {
//                     width: "33%",
//                     table: {
//                       widths: ["40%", "60%"],
//                       body: [
//                         [
//                           { text: " VOUCHER NO.", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.purchase_number || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "PROJECT", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.project_name || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         // [
//                         //   { text: "INDENT", bold: true, alignment: "left" },
//                         //   {
//                         //     text: `: ${indent.indent_no || "-"}`,
//                         //     alignment: "left",
//                         //   },
//                         // ],
//                         // [
//                         //   { text: "DIVISION", bold: true, alignment: "left" },
//                         //   {
//                         //     text: `: ${indent.division_name || "-"}`,
//                         //     alignment: "left",
//                         //   },
//                         // ],
//                         // [
//                         //   {
//                         //     text: "TRANSPORTER",
//                         //     bold: true,
//                         //     alignment: "left",
//                         //   },
//                         //   {
//                         //     text: `: ${indent.transporter || "-"}`,
//                         //     alignment: "left",
//                         //   },
//                         // ],
//                         [
//                           { text: "INVOICE NO.", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.invoice_number || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "STATUS", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.status || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                       ],
//                     },
//                     layout: "noBorders",
//                   },
//                   {
//                     width: "33%",
//                     table: {
//                       widths: ["40%", "60%"],
//                       body: [
//                         [
//                           { text: "SUPPLIER", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.supplier_name || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "LR NO.", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.lr_no || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "VEHICLE NO.", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.vehicle_no || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "TOTAL AMOUNT", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.total_amount ? `₹${Number(indent.total_amount).toLocaleString("en-IN")}` : "-"}`,
//                             alignment: "left",
//                           },
//                         ],

//                       ],
//                     },
//                     layout: "noBorders",
//                   },
//                   {
//                     width: "33%",
//                     table: {
//                       widths: ["40%", "60%"],
//                       body: [
//                         [
//                           { text: "REMARKS", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.remarks || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "PAYMENT STATUS", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.payment_status || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "CREATED BY", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.created_by_name || "-"}`,
//                             alignment: "left",
//                           },
//                         ],
//                         [
//                           { text: "APPROVED BY", bold: true, alignment: "left" },
//                           {
//                             text: `: ${indent.approved_by_name || "-"}`,
//                             alignment: "left",
//                           },
//                         ],

//                       ],
//                     },
//                     layout: "noBorders",
//                   },
//                 ],
//                 columnGap: 10,
//                 margin: [0, 0, 0, 0],
//               },
//             ],

//             // Row 3 - Items Table
//             [
//               {
//                 table: {
//                   headerRows: 1,
//                   widths: [
//                     "auto", // Sl. No.
//                     "*",    // Category

//                     "*",    // Item
//                     "auto", // Item Type ✅
//                     "auto", // UOM
//                     "auto", // PO Qty.
//                     "auto", // Received Qty.
//                     "auto", // Rate
//                     "auto", // Amount
//                     "auto", // Amount
//                     "auto", // Amount
//                     "auto", // Amount
//                   ],
//                   body: tableBody,
//                 },
//                 layout: {
//                   hLineWidth: () => 0.5,
//                   vLineWidth: () => 0.5,
//                   hLineColor: () => "#000",
//                   vLineColor: () => "#000",
//                   paddingLeft: () => 3,
//                   paddingRight: () => 3,
//                   paddingTop: () => 2,
//                   paddingBottom: () => 2,
//                 },
//               },
//             ],

//             // Row 4 - Total Value
//             [
//               {
//                 text: `Total Value        ${total}`,
//                 alignment: "right",
//                 bold: true,
//                 margin: [0, 5, 10, 5],
//               },
//             ],
//             [
//               {
//                 text: `Total GST        ${gst_amount}`,
//                 alignment: "right",
//                 bold: true,
//                 margin: [0, 5, 10, 5],
//               },
//             ],
//             [
//               {
//                 text: `Other Expenses        ${other_expense}`,
//                 alignment: "right",
//                 bold: true,
//                 margin: [0, 5, 10, 5],
//               },
//             ],
//             [
//               {
//                 text: `Final Value        ${final_amount}`,
//                 alignment: "right",
//                 bold: true,
//                 margin: [0, 5, 10, 5],
//               },
//             ],
//             // Row 5 - Footer Signatures
//             [
//               {
//                 table: {
//                   widths: ["33%", "34%", "33%"],
//                   body: [
//                     [
//                       {
//                         text: indent.created_by_name || "",
//                         alignment: "left",
//                         bold: true,
//                         margin: [0, 40, 0, 0],
//                       },
//                       {
//                         text: indent.approved_name || "",
//                         alignment: "center",
//                         bold: true,
//                         margin: [0, 40, 0, 0],
//                       },
//                       {
//                         text: `For, ${company.company_name || ""}`,
//                         alignment: "right",
//                         bold: true,
//                         margin: [0, 40, 0, 0],
//                       },
//                     ],
//                     [
//                       {
//                         text: "Prepared By",
//                         alignment: "left",
//                         bold: true,
//                         margin: [0, 0, 0, 10],
//                       },
//                       {
//                         text: "Verified By",
//                         alignment: "center",
//                         bold: true,
//                         margin: [0, 0, 0, 10],
//                       },
//                       {
//                         text: "Authorized Signatory",
//                         alignment: "right",
//                         bold: true,
//                         margin: [0, 0, 0, 10],
//                       },
//                     ],
//                   ],
//                 },
//                 layout: "noBorders",
//               },
//             ],
//           ],
//         },
//         layout: {
//           hLineWidth: () => 1,
//           vLineWidth: () => 1,
//           hLineColor: () => "#000",
//           vLineColor: () => "#000",
//         },
//       },
//     ],
//     styles: {
//       reportTitle: { fontSize: 13, bold: true, decoration: "underline" },
//       tableHeader: {
//         bold: true,
//         fontSize: 9,
//         fillColor: "#f5f5f5",
//         alignment: "center",
//       },
//     },
//     images: {
//       logoImg: logoImg,
//     },
//   };

//   pdfMake.createPdf(docDefinition).open();
// };

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getCompanyProfile } from "../../../Services/Services";
import config from "../../../config";

pdfMake.vfs = pdfFonts.vfs;

// 1x1 Transparent Blank PNG (Fallback so pdfMake never crashes)
const BLANK_IMAGE_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

// Safe Image to Base64 Converter
const imageUrlToBase64 = async (url) => {
  if (!url) return BLANK_IMAGE_BASE64;

  let fullUrl = url;
  // Agar relative URL hai to config se backend URL lagayein
  if (
    !url.startsWith("http://") &&
    !url.startsWith("https://") &&
    !url.startsWith("data:")
  ) {
    const baseUrl = config.staticBaseURL || "http://127.0.0.1:8000";
    fullUrl = `${baseUrl.replace(/\/$/, "")}/${url.replace(/^\//, "")}`;
  }

  try {
    const response = await fetch(fullUrl, { mode: "cors" });
    if (!response.ok) {
      console.warn("Company logo load failed with status:", response.status);
      return BLANK_IMAGE_BASE64;
    }

    const blob = await response.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result || BLANK_IMAGE_BASE64);
      reader.onerror = () => resolve(BLANK_IMAGE_BASE64);
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("Failed to fetch image for PDF:", fullUrl, err);
    return BLANK_IMAGE_BASE64;
  }
};

export const generatePurchasePdf = async (indent) => {
  let company = {};
  try {
    company = await getCompanyProfile();
  } catch (err) {
    console.warn("Failed to fetch company profile:", err);
  }

  const logoImg = company.logo_url
    ? await imageUrlToBase64(company.logo_url)
    : BLANK_IMAGE_BASE64;

  const tableBody = [
    [
      { text: "Sl. No.", style: "tableHeader" },
      { text: "Category", style: "tableHeader" },
      { text: "Item", style: "tableHeader" },
      { text: "Product Type", style: "tableHeader" },
      { text: "UOM", style: "tableHeader" },
      { text: "PO Qty.", style: "tableHeader" },
      { text: "Received Qty.", style: "tableHeader" },
      { text: "Rate", style: "tableHeader" },
      { text: "Amount", style: "tableHeader" },
      { text: "Gst Per", style: "tableHeader" },
      { text: "GST Amt", style: "tableHeader" },
      { text: "Total Amt", style: "tableHeader" },
    ],
    ...(indent.items || []).map((item, i) => [
      { text: i + 1, alignment: "center" },
      { text: item.category_name || "-", alignment: "center" },
      { text: item.item_name || "-", alignment: "center" },
      { text: item.size_name || "-", alignment: "center", fontSize: 8 },
      { text: item.unit_name || "-", alignment: "center" },
      { text: item.quantity ?? "-", alignment: "center" },
      { text: item.received_qty ?? "-", alignment: "center" },
      {
        text: item.rate ? `Rs. ${item.rate}` : "-",
        alignment: "center",
      },
      {
        text: item.amount
          ? `₹${Number(item.amount).toLocaleString("en-IN")}`
          : "-",
        alignment: "center",
      },
      {
        text: item.gst_percentage
          ? `${Number(item.gst_percentage).toLocaleString("en-IN")}`
          : "-",
        alignment: "center",
      },
      {
        text: item.gst_amount
          ? `₹${Number(item.gst_amount).toLocaleString("en-IN")}`
          : "-",
        alignment: "center",
      },
      {
        text: item.item_total
          ? `₹${Number(item.item_total).toLocaleString("en-IN")}`
          : "-",
        alignment: "center",
      },
    ]),
  ];

  const total = `₹${(indent.items || [])
    .reduce((sum, i) => sum + (parseFloat(i.amount) || 0), 0)
    .toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const gst_amount = indent.gst_amount
    ? `₹${Number(indent.gst_amount).toLocaleString("en-IN")}`
    : "-";
  const final_amount = `₹${(
    parseFloat(indent.final_amount) || 0
  ).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  const other_expense = indent.other_expense
    ? `₹${Number(indent.other_expense).toLocaleString("en-IN")}`
    : "-";

  const docDefinition = {
    pageOrientation: "landscape",
    pageSize: "A4",
    pageMargins: [10, 10, 10, 10],
    defaultStyle: { fontSize: 9 },

    footer: function (currentPage, pageCount) {
      return {
        text: "Page " + currentPage + " of " + pageCount,
        alignment: "right",
        fontSize: 8,
        italics: true,
        margin: [0, 5, 20, 0],
      };
    },
    content: [
      {
        table: {
          widths: ["100%"],
          body: [
            // Row 1 - Header with logo and company details
            [
              {
                table: {
                  widths: [80, "*"],
                  body: [
                    [
                      {
                        image: "logoImg",
                        width: 80,
                        rowSpan: 2,
                        margin: [0, 0, 5, 0],
                      },
                      {
                        text: `${company.company_name || ""}\n${
                          company.tagline || ""
                        }\n${company.address || ""}\nPhone: ${
                          company.phone || ""
                        } | Email: ${company.email || ""}`,
                        alignment: "center",
                        bold: true,
                        margin: [0, 0, 0, 0],
                      },
                    ],
                    [
                      {},
                      {
                        columns: [
                          { width: "*", text: "" },
                          {
                            table: {
                              widths: ["auto"],
                              body: [
                                [
                                  {
                                    text: "Purchase List",
                                    alignment: "center",
                                    fontSize: 10,
                                    bold: true,
                                    margin: [30, 0, 30, 0],
                                    border: [true, true, true, true],
                                  },
                                ],
                              ],
                            },
                            layout: {
                              hLineWidth: () => 0.3,
                              vLineWidth: () => 0.3,
                              hLineColor: () => "#000",
                              vLineColor: () => "#000",
                            },
                            margin: [50, 0, 0, 0],
                          },
                          { width: "*", text: "" },
                        ],
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],

            // Row 2 - Purchase Details Info
            [
              {
                columns: [
                  {
                    width: "33%",
                    table: {
                      widths: ["40%", "60%"],
                      body: [
                        [
                          { text: " VOUCHER NO.", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.purchase_number || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "PROJECT", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.project_name || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "INVOICE NO.", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.invoice_number || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "STATUS", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.status || "-"}`,
                            alignment: "left",
                          },
                        ],
                      ],
                    },
                    layout: "noBorders",
                  },
                  {
                    width: "33%",
                    table: {
                      widths: ["40%", "60%"],
                      body: [
                        [
                          { text: "SUPPLIER", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.supplier_name || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "LR NO.", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.lr_no || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "VEHICLE NO.", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.vehicle_no || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "TOTAL AMOUNT", bold: true, alignment: "left" },
                          {
                            text: `: ${
                              indent.total_amount
                                ? `₹${Number(indent.total_amount).toLocaleString("en-IN")}`
                                : "-"
                            }`,
                            alignment: "left",
                          },
                        ],
                      ],
                    },
                    layout: "noBorders",
                  },
                  {
                    width: "33%",
                    table: {
                      widths: ["40%", "60%"],
                      body: [
                        [
                          { text: "REMARKS", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.remarks || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "PAYMENT STATUS", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.payment_status || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "CREATED BY", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.created_by_name || "-"}`,
                            alignment: "left",
                          },
                        ],
                        [
                          { text: "APPROVED BY", bold: true, alignment: "left" },
                          {
                            text: `: ${indent.approved_by_name || "-"}`,
                            alignment: "left",
                          },
                        ],
                      ],
                    },
                    layout: "noBorders",
                  },
                ],
                columnGap: 10,
                margin: [0, 0, 0, 0],
              },
            ],

            // Row 3 - Items Table
            [
              {
                table: {
                  headerRows: 1,
                  widths: [
                    "auto",
                    "*",
                    "*",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                  ],
                  body: tableBody,
                },
                layout: {
                  hLineWidth: () => 0.5,
                  vLineWidth: () => 0.5,
                  hLineColor: () => "#000",
                  vLineColor: () => "#000",
                  paddingLeft: () => 3,
                  paddingRight: () => 3,
                  paddingTop: () => 2,
                  paddingBottom: () => 2,
                },
              },
            ],

            // Row 4 - Total Value
            [
              {
                text: `Total Value        ${total}`,
                alignment: "right",
                bold: true,
                margin: [0, 5, 10, 5],
              },
            ],
            [
              {
                text: `Total GST        ${gst_amount}`,
                alignment: "right",
                bold: true,
                margin: [0, 5, 10, 5],
              },
            ],
            [
              {
                text: `Other Expenses        ${other_expense}`,
                alignment: "right",
                bold: true,
                margin: [0, 5, 10, 5],
              },
            ],
            [
              {
                text: `Final Value        ${final_amount}`,
                alignment: "right",
                bold: true,
                margin: [0, 5, 10, 5],
              },
            ],
            // Row 5 - Footer Signatures
            [
              {
                table: {
                  widths: ["33%", "34%", "33%"],
                  body: [
                    [
                      {
                        text: indent.created_by_name || "",
                        alignment: "left",
                        bold: true,
                        margin: [0, 40, 0, 0],
                      },
                      {
                        text: indent.approved_name || "",
                        alignment: "center",
                        bold: true,
                        margin: [0, 40, 0, 0],
                      },
                      {
                        text: `For, ${company.company_name || ""}`,
                        alignment: "right",
                        bold: true,
                        margin: [0, 40, 0, 0],
                      },
                    ],
                    [
                      {
                        text: "Prepared By",
                        alignment: "left",
                        bold: true,
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Verified By",
                        alignment: "center",
                        bold: true,
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Authorized Signatory",
                        alignment: "right",
                        bold: true,
                        margin: [0, 0, 0, 10],
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#000",
          vLineColor: () => "#000",
        },
      },
    ],
    styles: {
      reportTitle: { fontSize: 13, bold: true, decoration: "underline" },
      tableHeader: {
        bold: true,
        fontSize: 9,
        fillColor: "#f5f5f5",
        alignment: "center",
      },
    },
    images: {
      logoImg: logoImg || BLANK_IMAGE_BASE64,
    },
  };

  pdfMake.createPdf(docDefinition).open();
};